import type { IUser } from "@upmind-automation/types";

export default {
  computed: {
    loggedUser(): IUser {
      return this.$store.state.user;
    }
  }
};
